import PropTypes from 'prop-types';
import React from 'react';

import BiomeBanner from './BiomeBanner';
import BiomeSummaryButton from './BiomeSummaryButton';
import Climatogram from './Climatogram';
import GradientBackground from './GradientBackground';
import WildlifeSummary from './WildlifeSummary';

const BiomeSummary = ({
  locationInfo,
  isFavorite,
  isBusy,
  onInfoButtonPressed,
  onCompareButtonPressed,
  onSaveButtonPressed}) => {

  return (
    <div className="BiomeSummary">
      <BiomeBanner
        geocodedName={locationInfo.displayName}
        coordinates={locationInfo.location.getCoordinateString()}
        biomeName={locationInfo.biomeName}
        imageBlob={locationInfo.bannerImageDef &&
          locationInfo.bannerImageDef.image}
        isBusy={isBusy}
      />

      <GradientBackground
        startColor={locationInfo.gradientStartColor}
        endColor={locationInfo.gradientEndColor}
      >
        <Climatogram
          precipData={locationInfo.precipData}
          tempData={locationInfo.tempData}
          compact={true}
          displayHeader={true}
        />

        <WildlifeSummary
          wildlifeInfo={locationInfo.wildlifeInfo}
        />

        <div className="BiomeSummary__buttonContainer">
          <BiomeSummaryButton
            title={"More"}
            styleName={"info"}
            onClick={onInfoButtonPressed} />
          <div className="BiomeSummary__actionButtonDivider" />
          <BiomeSummaryButton
            title={"Compare"}
            styleName={"compare"}
            onClick={onCompareButtonPressed} />
          <div className="BiomeSummary__actionButtonDivider" />
          <BiomeSummaryButton
            title={isFavorite ? "Saved" : "Save"}
            styleName={isFavorite ? "unsave" : "save"}
            onClick={onSaveButtonPressed} />
        </div>
      </GradientBackground>
    </div>
  );
};

BiomeSummary.propTypes = {
  location: PropTypes.object.isRequired,
  isBusy: PropTypes.bool.isRequired,
  onInfoButtonPressed: PropTypes.func.isRequired,
  onCompareButtonPressed: PropTypes.func.isRequired,
  onSaveButtonPressed: PropTypes.func.isRequired,
};

export default BiomeSummary;



// WEBPACK FOOTER //
// ./src/components/BiomeSummary.js